import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import { Icon } from '@ui';

import { menuBarItemClassName, menuBarItemTextClassName } from './menu-bar.styles';

import { MenuBarItem } from '@/constants/menu-bar-data';

type MenuBarItemProps = {
  isCollapsed: boolean;
  itemMenu: MenuBarItem;
  soon?: boolean;
};

const MenuBarElement: FC<MenuBarItemProps> = (props) => {
  const { isCollapsed, itemMenu, soon } = props;
  const { id, name, icon, route, iconSize, iconSizeHidden, routeEnd } = itemMenu;

  return (
    <li key={id}>
      <NavLink
        to={route}
        className={({ isActive }) =>
          cn(menuBarItemClassName({ isActive, isCollapsed }), `${soon && 'pointer-events-none'}`)
        }
        end={routeEnd}
      >
        <div className="inline-flex items-center overflow-y-hidden overflow-x-hidden">
          <Icon
            className="text-speech_analitics"
            name={icon}
            size={isCollapsed ? iconSizeHidden || 25 : iconSize || 18}
          />
          {!isCollapsed && (
            <span className={cn(menuBarItemTextClassName, `${soon && 'text-4color'}`)}>{name}</span>
          )}
          {soon && <div className="self-start text-[9px] ml-2 text-4color">(Скоро)</div>}
        </div>
      </NavLink>
    </li>
  );
};

export default MenuBarElement;
